/** Agilysys logo mark (circles only — no wordmark). */
export const AGILYSYS_LOGO_MARK_URL =
  "https://agilysys.com/en/wp-content/uploads/Agilysys-Logo-only-RGB.svg";

/** Full Agilysys wordmark bundled in /public (circles + agilysys text). */
export const AGILYSYS_LOGO_URL = `${process.env.PUBLIC_URL || ""}/agilysys-logo.png`;
